import React from 'react'
import './Calendar.css'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import firebase from 'firebase/app'
import 'firebase/database'
import {initializeFirebase} from '../firebaseDatabase'
import store from '../redux';
import image2 from '../assets/modalImg2.svg'
import imageSelamat1 from '../assets/selamat1.svg'
import imageSelamat2 from '../assets/selamat2.svg'
import imageSelamat3 from '../assets/selamat3.svg'
import imageSelamat4 from '../assets/selamat4.svg'
import imageSelamat5 from '../assets/selamat5.svg'
import imageSelamat6 from '../assets/selamat6.svg'
import imageSelamat7 from '../assets/selamat7.svg'
import imageSelamat8 from '../assets/selamat8.svg'
import imageSelamat9 from '../assets/selamat9.svg'
import imageSelamat10 from '../assets/selamat10.svg'
import imageSelamat11 from '../assets/selamat11.svg'
import imageSelamat12 from '../assets/selamat12.svg'
import $ from 'jquery';
window.jQuery = $;
window.$ = $;
global.jQuery = $;

const color = '#5cb85c'
const colorFailed = '#f0ad4e'


class Home extends React.Component {
    constructor(props) {
      super(props);
      this.state ={
        data : [],
        pureData : [],
        title: '',
        selectInfo: [],
        eventInfo: [],
        eventCalendarInfo: [],
        googleId: '',
        gift: [
          {"quote" : "Kebahagian tidak diukur dari seberapa banyak yang dimiliki, tetapi dari perasaan mensyukuri apa yang dimiliki.", "name" : "Anonymous"}
          ,{"quote" : "Masa depan memberi penghargaan bagi mereka yang terus maju. Saya tidak punya waktu untuk mengasihani diri sendiri. Saya tidak punya waktu untuk mengeluh. Saya akan teruskan.", "name" : "Barack Obama" }
          ,{"quote" : "Untuk meraih cita-cita besar, kita tak hanya perlu bertindak, namun juga bermimpi. tak hanya perlu merencanakan, namun harus meyakini.", "name" : "Anatole France"}
          ,{"quote" : "Jika ada harapan di masa depan, secara harfiah ada kekuatan di masa sekarang.", "name" : "Zig Ziglar"}
          ,{"quote" : "Ubah hidup kamu hari ini. Jangan bertaruh untuk masa depan, bertindaklah sekarang, tanpa penundaan.", "name" : "Simone de Beauvoir"}
          ,{"quote" : "Saat kamu melakukan sesuatu dan gagal, kamu mendapatkan hikmah. Jika tidak melakukan apa-apa artinya kamu kalah oleh rasa takut.", "name" : "Anonymous"}
          ,{"quote" : "Ingatlah impianmu dan perjuangkanlah untuk itu. Kamu harus tahu apa yang kamu inginkan dari kehidupan. Hanya ada satu hal yang membuat impianmu menjadi mustahil, yaitu ketakutan akan kegagalan.", "name" : "Paulo Coelho"}
          ,{"quote" : "Tinggalkan pikiran yang membuatmu lemah, dan peganglah pikiran yang memberi kekuatan bagimu.", "name" : "Anonymous"}
          ,{"quote" : "Berpikir positif adalah salah satu cara terbaik ketika tidak punya pilihan.", "name" : "Chairul Tanjung"}
          ,{"quote" : "Satu-satunya cara melakukan pekerjaan besar adalah dengan mencintai apa yg anda kerjakan", "name" : "Steve Job"}
          ,{"quote" : "Tidak ada yang tidak mungkin di dunia ini,apa yang kamu inginkan pasti bisa kamu dapatkan, asal sabar, usaha,dan ikhlas dalam doa.", "name" : "Anonymous"}
          ,{"quote" : "Kita memang tidak selalu mendapatkan apa yang kita inginkan, namun percayalah, Tuhan memberikan apa yang kita butuhkan.", "name" : "Anonymous"}
          ,{"quote" : "Kesuksesan bukan akhir, kegagalan bukan hal yang fatal: itu adalah keberanian untuk melanjutkan apa yang penting", "name" : "Winston Churchill"}
          ,{"quote" : "Jadilah dirimu sendiri, ekspresikan dirimu sendiri, yakinlah pada dirimu sendiri, jangan pergi dan mencari kepribadian sukses dan menduplikasinya", "name" : "Bruce Lee"}
          ,{"quote" : "Aksi adalah kunci dasar untuk semua kesuksesan", "name" : "Pablo Picasso"}
          ,{"quote" : "Sukses bukanlah kunci kebahagiaan. Kebahagiaan adalah kunci kesuksesan. Jika Anda mencintai pekerjaan Anda, Anda akan menjadi orang yang sukses", "name" : "Albert Schweitzer"}
          ,{"quote" : "Sukses terdiri dari keberlanjutan kesalahan demi kesalahan tanpa kehilangan rasa antusias", "name" : "Winston Churchill"}
          ,{"quote" : "Sukses itu tidak lebih dari beberapa hal sederhana yang dilakukan secara disiplin dan dipraktikkan setiap hari", "name" : "Jim Rohm"}
          ,{"quote" : "Sukses adalah guru yang buruk. Ia menggoda orang pintar berpikir bahwa mereka tidak terkalahkan", "name" : "Bill Gates"}
          ,{"quote" : "Jangan menjadikan sukses sebagai tujuan, lakukan apa yang Anda cintai dan percayai maka sukses akan datang dengan sendirinya ", "name" : "David Frost"}
          ,{"quote" : "Orang yang sukses adalah orang yang bisa bersandar pada sandaran yang kuat sementara ia menerima lemparan banyak batu-bata", "name" : "David Brinkley"}
          ,{"quote" : "Saya sudah gagal berkali-kali dalam hidup saya dan itulah mengapa saya sukses", "name" : "Michael Jordan"}
          ,{"quote" : "Selalu ingat dalam pikiran bahwa resolusi Anda terhadap kesuksesan jauh lebih penting dari apapun", "name" : "Abraham Lincoln"}
          ,{"quote" : "Sukses tidak diukur dari uang atau kekuatan atau status sosial. Sukses diukur dari kedisiplinan dan kecantikan dalam diri Anda", "name" : "Mike Ditka"}
          ,{"quote" : "Tidak pernah ada kata terlambat untuk menjadi orang yang Anda inginkan", "name" : "George Eliot"}
          ,{"quote" : "Tidak ada lelaki yang sukses tanpa wanita yang baik di belakangnya. Baik istri atau ibu, jika ia memiliki keduanya, ia sudah pasti mendapat berkat 2 kali", "name" : "Godfrey Winn"}
          ,{"quote" : "Hanya ada satu kesuksesan, yaitu menjadi mampu menghabiskan hidup Anda menurut jalan Anda sendiri", "name" : "Christopher Morley"}
          ,{"quote" : "Ketika cinta dan kerja keras bersama, Anda bisa mengharapkan sebuah mahakarya", "name" : "John Ruskin"}
          ,{"quote" : "Sebagian besar yang Anda inginkan adalah di luar zona kenyamanan Anda", "name" : "Jack Canfield"}
        ],
        imgNumber: 1,
        quoteNumber: 0
      }
      this.handleChange = this.handleChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
      this.handleDelete = this.handleDelete.bind(this);
      this.handleEdit = this.handleEdit.bind(this);
      this.handleSubmitEdit = this.handleSubmitEdit.bind(this);
      this.handleDone = this.handleDone.bind(this);
    } 

    componentDidMount () {
      this.getAllFirebaseData();
    }

    getAllFirebaseData() {
      if (!firebase.apps.length) {
        initializeFirebase();
      }
      firebase.database().ref('/'+store.getState().state.googleId+store.getState().state.email.replace(/[^a-zA-Z0-9]/g, '')+'/calendar').once('value').then(snap => {
        this.setState({
          data : snap.val() !== null ? Object.values(snap.val()) : snap.val(), 
          pureData : snap.val() 
        })
        if(snap.val() === null)$(this.modal5).modal('show');
      });
    }


    render() {
      return (
        <div className="calendar jumbotron-fluid" style={this.props.expanded ? {paddingLeft:20+"%"} : {paddingLeft:5+"%"} }>
            <div className="container">
              <FullCalendar
                  plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                  headerToolbar={{
                  left: 'today',
                  center: 'title',
                  right: 'prevYear,prev,next,nextYear'
                  }}
                  initialView='dayGridMonth'
                  events={this.state.data}
                  editable={true}
                  selectable={true}
                  // dayMaxEvents={true}
                  // datesSet={this.handleDates}
                  select={this.handleDateSelect}
                  // events={this.props.events}
                  // eventContent={this.renderEventContent} // custom render function
                  eventClick={this.handleEventClick}
                  // eventAdd={this.handleEventAdd}
                  eventChange={this.handleEventChange} // called for drag-n-drop/resize
                  // eventRemove={this.handleEventRemove}
              />
              <div className="text-left mt-3">
                <p>
                  <span>Keterangan: &emsp;</span>
                  <i className="fa fa-square border rounded" style={{color:'#fdfbe2'}} aria-hidden="true"></i> Hari ini&emsp;
                  <i className="fa fa-circle" style={{color:color}} aria-hidden="true"></i> Resolusi Berhasil &emsp;
                  <i className="fa fa-circle" style={{color:colorFailed}} aria-hidden="true"></i> Resolusi Gagal &emsp;
                  <i className="fa fa-circle" style={{color:'#0275d8'}} aria-hidden="true"></i> Resolusi Belum Tercapai&emsp;
                  <button type="button" onClick={() => $(this.modal5).modal('show')} className="btn btn-info float-right mt-0" data-toggle="modal5" data-target="#modal5"><i className="fa fa-info" aria-hidden="true"></i></button>
                </p>
                
              </div>

              <div className="modal fade" ref={modal1 => this.modal1 = modal1} id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title mx-auto" id="exampleModalLabel">Silahkan resolusi yang ingin kamu capai..</h5>
                      {/* <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button> */}
                    </div>
                    <form onSubmit={this.handleSubmit}>
                      <div className="modal-body">
                          <label>
                            <input type="text" className="form-control form-control-md" style={{width:'100%'}} value={this.state.title} onChange={this.handleChange} placeholder="Tulis disini...."/>
                          </label>
                      </div>
                      <div className="modal-footer ">
                        <button type="submit" className="btn btn-primary ml-auto">Simpan</button>
                        <button type="button" className="btn btn-secondary mr-auto" data-dismiss="modal">Tutup</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              <div className="modal fade" ref={modal2 => this.modal2 = modal2} id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">Resolusi</h5>
                      <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                      <div className="modal-body">
                          <label>
                              {this.state.eventInfo.title}
                          </label>
                      </div>
                      <div className="modal-footer ">
                        <button type="button" className="btn btn-success  ml-auto" onClick={() =>  this.handleDone('1')} data-dismiss="modal">Selesai</button>
                        <button type="button" className="btn btn-warning" onClick={() => this.handleDone('0')} data-dismiss="modal">Gagal</button>
                        <button type="button" className="btn btn-info" onClick={this.handleEdit}>Ubah</button>
                        <button type="button" className="btn btn-danger mr-auto" onClick={this.handleDelete} data-dismiss="modal">Hapus</button>
                      </div>
                  </div>
                </div>
              </div>

              <div className="modal fade" ref={modal3 => this.modal3 = modal3} id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">Ubah Resolusi</h5>
                      <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <form onSubmit={this.handleSubmitEdit}>
                      <div className="modal-body">
                          <label>
                            <input type="text" className="form-control form-control-md" style={{width:'100%'}} value={this.state.title} onChange={this.handleChange} placeholder="Tulis disini...."/>
                          </label>
                      </div>
                      <div className="modal-footer ">
                        <button type="submit" className="btn btn-primary ml-auto">Simpan</button>
                        <button type="button" className="btn btn-secondary mr-auto" onClick={() => this.setState({title:''})} data-dismiss="modal">Batal</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              <div className="modal fade" ref={modal4 => this.modal4 = modal4} id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">Resolusi yang berhasil dicapai</h5>
                      <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                      <div className="modal-body">
                          <label>
                              {this.state.eventInfo.title}
                          </label>
                      </div>
                      <div className="modal-footer ">
                        <button type="button" className="btn btn-info ml-auto" onClick={() => this.handleDone('2')} data-dismiss="modal">Pulihkan</button>
                        <button type="button" className="btn btn-danger mr-auto" onClick={this.handleDelete} data-dismiss="modal">Hapus</button>
                      </div>
                  </div>
                </div>
              </div>

              <div className="modal fade" ref={modal5 => this.modal5 = modal5} id="modal5" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title mx-auto" id="exampleModalLabel">Petunjuk</h5>
                    </div>
                      <div className="modal-body text-center modal5">
                          <img src={image2} className="img-fluid m-3" style={{height:"15vh"}} alt="" />
                          <p className="text-justify">- Anda bisa <span className="font-weight-bold">menambahkan</span> resolusi dengan <span className="onWeb">meng-<span className="font-italic">click</span> atau <span className="font-italic">click and drag</span> tanggal </span><span className="onMobile"><span className="font-italic">click and hold</span> tanggal <span className="font-italic"></span></span>yang anda inginkan</p>
                          <p className="text-justify">- Anda bisa <span className="font-weight-bold">melihat detail</span> dan <span className="font-italic font-weight-bold">action</span> selanjutnya yang akan anda lakukan dengan meng-<span className="font-italic">click</span> resolusi yang telah anda buat </p>
                          <p className="text-justify">- <span className="font-italic font-weight-bold">Action</span> yang bisa kamu pilih adalah <span className="font-weight-bold">Selesai, Gagal, Ubah,</span>atau <span className="font-weight-bold">Hapus</span> resolusi tersebut</p>
                          <p className="text-justify">- Anda bisa <span className="font-weight-bold">memperbesar</span> atau <span className="font-weight-bold">memperkecil waktu</span> resolusi dengan  meng-<span className="font-italic">click and drag</span> pada bagian <span className="font-italic">border</span> sebelah kanan resolusi terkait</p>
                          <p className="text-justify">- Anda bisa <span className="font-weight-bold">memindahkan</span> resolusi yang telah anda buat secara langsung dengan meng-<span className="font-italic">click and drag</span> resolusi tersebut</p>
                          <p className="text-justify">- Jika anda telah Selesai atau Gagal pada resolusi tertentu dan ingin <span className="font-weight-bold">memulihkan / mengembalikan kembali</span> anda bisa meng-<span className="font-italic">click</span> tombol <span className="font-weight-bold">Pulihkan</span> pada detail resolusi tersebut </p>
                          <p className="text-justify">- Semua <span className="font-weight-bold">data</span> akan tersimpan secara otomatis </p>
                      </div>
                      <div className="modal-footer ">
                        <button type="button" className="btn btn-secondary mx-auto" data-dismiss="modal">OK</button>
                      </div>
                  </div>
                </div>
              </div>

              <div className="modal fade modal6" ref={modal6 => this.modal6 = modal6} id="modal6" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title mx-auto" id="exampleModalLabel">Selamat Ya {store.getState() !== '' ? store.getState().state.name : ''} <i className="fa fa-gift" aria-hidden="true"></i></h5>
                    </div>
                      <div className="modal-body text-center">
                          { this.state.imgNumber === 1 ? <img src={imageSelamat1} className="img-fluid m-3" style={{height:"40vh"}} alt=""/> : ''}
                          { this.state.imgNumber === 2 ? <img src={imageSelamat2} className="img-fluid m-3" style={{height:"40vh"}} alt=""/> : ''}
                          { this.state.imgNumber === 3 ? <img src={imageSelamat3} className="img-fluid m-3" style={{height:"40vh"}} alt=""/> : ''}
                          { this.state.imgNumber === 4 ? <img src={imageSelamat4} className="img-fluid m-3" style={{height:"40vh"}} alt=""/> : ''}
                          { this.state.imgNumber === 5 ? <img src={imageSelamat5} className="img-fluid m-3" style={{height:"40vh"}} alt=""/> : ''}
                          { this.state.imgNumber === 6 ? <img src={imageSelamat6} className="img-fluid m-3" style={{height:"40vh"}} alt=""/> : ''}
                          { this.state.imgNumber === 7 ? <img src={imageSelamat7} className="img-fluid m-3" style={{height:"40vh"}} alt=""/> : ''}
                          { this.state.imgNumber === 8 ? <img src={imageSelamat8} className="img-fluid m-3" style={{height:"40vh"}} alt=""/> : ''}
                          { this.state.imgNumber === 9 ? <img src={imageSelamat9} className="img-fluid m-3" style={{height:"40vh"}} alt=""/> : ''}
                          { this.state.imgNumber === 10 ? <img src={imageSelamat10} className="img-fluid m-3" style={{height:"40vh"}} alt=""/> : ''}
                          { this.state.imgNumber === 11 ? <img src={imageSelamat11} className="img-fluid m-3" style={{height:"40vh"}} alt=""/> : ''}
                          { this.state.imgNumber === 12 ? <img src={imageSelamat12} className="img-fluid m-3" style={{height:"40vh"}} alt=""/> : ''}
                          <p className="text-center">" {this.state.gift[this.state.quoteNumber].quote} "</p>
                          <p className="text-center font-italic">- {this.state.gift[this.state.quoteNumber].name} -</p>
                          
                      </div>
                      <div className="modal-footer ">
                        <button type="button" className="btn btn-secondary mx-auto" data-dismiss="modal">OK</button>
                      </div>
                  </div>
                </div>
              </div>

            </div>
        </div>
        )
    }

    //============= Handle Event =============
    handleChange(event) {
      this.setState({title: event.target.value});
    }

    handleSubmit(event) {
      let title = this.state.title
      let selectInfo = this.state.selectInfo
      // let calendarApi = selectInfo.view.calendar
        
      if (title) {
        // calendarApi.addEvent({ // will render immediately. will call handleEventAdd
        //   title,
        //   start: selectInfo.startStr,
        //   end: selectInfo.endStr,
        //   allDay: selectInfo.allDay
        // }, true) // temporary=true, will get overwritten when reducer gives new events
      
        // Get a key for a new Post.
        var newKey = firebase.database().ref().child('posts').push().key;
        var postData = {
          title : title, 
          start: selectInfo.startStr,
          end: selectInfo.endStr,
          allDay: selectInfo.allDay
        };
        var updates = {};
        updates['/'+store.getState().state.googleId+store.getState().state.email.replace(/[^a-zA-Z0-9]/g, '')+'/calendar/'+ newKey] = postData;
        firebase.database().ref().update(updates);
      }

      this.setState({title: ''});
      event.preventDefault();
      event.target.reset();
      $(this.modal1).modal('hide');
      this.getAllFirebaseData();
    }

    handleDelete() {
        let eventInfo = this.state.eventInfo
        var newKey = Object.keys(this.state.pureData)[this.state.data.findIndex(e => e.title === eventInfo.title && e.start === eventInfo.startStr && e.end === eventInfo.endStr)]
        var updates = {};
        updates['/'+store.getState().state.googleId+store.getState().state.email.replace(/[^a-zA-Z0-9]/g, '')+'/calendar/' + newKey] = null;
        firebase.database().ref().update(updates);
        eventInfo.remove()
    }

    handleEdit() {
      $(this.modal2).modal('hide');
      this.setState({
        title : this.state.eventInfo.title
      })
      $(this.modal3).modal('show');
    }

    handleSubmitEdit(event) {
      let calendarApi = this.state.eventCalendarInfo.calendar
      let eventInfo = this.state.eventInfo
      var newKey = Object.keys(this.state.pureData)[this.state.data.findIndex(e => e.title === eventInfo.title && e.start === eventInfo.startStr && e.end === eventInfo.endStr)]
      var postData = {
        title : this.state.title, 
        start: eventInfo.startStr,
        end: eventInfo.endStr,
        allDay: eventInfo.allDay
      };
      var updates = {};
      updates['/'+store.getState().state.googleId+store.getState().state.email.replace(/[^a-zA-Z0-9]/g, '')+'/calendar/'+newKey] = postData;
      firebase.database().ref().update(updates);


      if (this.state.title !== eventInfo.title) {
        calendarApi.addEvent({ // will render immediately. will call handleEventAdd
          title : this.state.title, 
          start: eventInfo.startStr,
          end: eventInfo.endStr,
          allDay: eventInfo.allDay
        }, true) // temporary=true, will get overwritten when reducer gives new events

        eventInfo.remove()
      }
      

      this.setState({title: ''});
      event.preventDefault();
      event.target.reset();
      $(this.modal3).modal('hide');
      this.getAllFirebaseData();
    }

    handleDone(i) {
      let calendarApi = this.state.eventCalendarInfo.calendar
      let eventInfo = this.state.eventInfo
      let colorBtn = ''
      if(i === '0') colorBtn = colorFailed;
      if(i === '1') colorBtn = color;
      var newKey = Object.keys(this.state.pureData)[this.state.data.findIndex(e => e.title === eventInfo.title && e.start === eventInfo.startStr && e.end === eventInfo.endStr)]
      var postData = {
        title : eventInfo.title, 
        start: eventInfo.startStr,
        end: eventInfo.endStr,
        allDay: eventInfo.allDay,
        color : colorBtn
      };
      var updates = {};
      updates['/'+store.getState().state.googleId+store.getState().state.email.replace(/[^a-zA-Z0-9]/g, '')+'/calendar/' + newKey] = postData;
      firebase.database().ref().update(updates);


      calendarApi.addEvent({ // will render immediately. will call handleEventAdd
        title : eventInfo.title, 
        start: eventInfo.startStr,
        end: eventInfo.endStr,
        allDay: eventInfo.allDay,
        color : colorBtn
      }, true) // temporary=true, will get overwritten when reducer gives new events

      eventInfo.remove()

      this.setState({
        imgNumber : (Math.floor(Math.random() * (12 - 1 + 1)) + 1),
        quoteNumber : (Math.floor(Math.random() * (28 - 0 + 1)) + 0)
      })
      if(i === '1') $(this.modal6).modal('show')
      
    }


    //============= Handle Event for Calendar =============
    handleDateSelect = (selectInfo) => {
      $(this.modal1).modal('show');
      let calendarApi = selectInfo.view.calendar
      calendarApi.unselect() // clear date selection
      this.setState({
        selectInfo : selectInfo
      })
    }

    handleEventClick = (clickInfo) => {
      if(clickInfo.event.backgroundColor !== color && clickInfo.event.backgroundColor !== colorFailed) {
        $(this.modal2).modal('show');
      } else {
        $(this.modal4).modal('show');
      }     
      
      this.setState({
        eventInfo: clickInfo.event,
        eventCalendarInfo: clickInfo.view
      })
    }

    handleEventChange = (changeInfo) => {
      let oldEventInfo = changeInfo.oldEvent
      let eventInfo = changeInfo.event
      
      var newKey = Object.keys(this.state.pureData)[this.state.data.findIndex(e => e.title === oldEventInfo.title && e.start === oldEventInfo.startStr && e.end === oldEventInfo.endStr)]
      var postData = {
        title : eventInfo.title, 
        start: eventInfo.startStr,
        end: eventInfo.endStr,
        allDay: eventInfo.allDay,
        color: oldEventInfo.backgroundColor  
      };
      var updates = {};
      updates['/'+store.getState().state.googleId+store.getState().state.email.replace(/[^a-zA-Z0-9]/g, '')+'/calendar/'+ newKey] = postData;
      firebase.database().ref().update(updates);
      this.getAllFirebaseData();
    }


}

export default Home;